const isObj = require('lodash.get');

export const getCmsWidgets = (state) => isObj(state, 'cmsWidgets', []);
export const getCmsWidgetDetailsById = (state) => isObj(state, 'cmsWidgetDetailsById', []);
